export const headerHeight = {
    phone: 70,
    tablet: 75,
    desktop: 90,
};
